import { useCallback } from "react";
import { useConfigContext } from "@hooks/useConfigContext";

/**
 * Custom hook that provides reusable mobile search actions
 */
export const useMobileSearchActions = () => {
  const { dispatch } = useConfigContext();

  const closeMobileSearch = useCallback(() => {
    dispatch({
      type: "MOBILE_SEARCH_VISIBILITY",
      payload: { visible: false },
    });
    dispatch({
      type: "SEARCH_VISIBILITY",
      payload: { visible: false },
    });
  }, [dispatch]);

  const openMobileSearch = useCallback(() => {
    dispatch({
      type: "MOBILE_SEARCH_VISIBILITY",
      payload: { visible: true },
    });
    dispatch({
      type: "SEARCH_VISIBILITY",
      payload: { visible: true },
    });
  }, [dispatch]);

  return {
    closeMobileSearch,
    openMobileSearch,
  };
};
